import React, {useEffect, useRef} from 'react';
import {IPoint, IShape} from '../../incase-domain/elements/question/imageMarkup';

interface CanvasQuestionMarkedAreasProps {
    markedAreas?: IShape[];
    width: number;
    height: number;
    fillStyle?: string;
    strokeStyle?: string;
    lineWidth?: number;
}

function CanvasQuestionMarkedAreas(props: CanvasQuestionMarkedAreasProps): JSX.Element | null {
    const {markedAreas, width, height, fillStyle = 'rgba(255, 0, 0, 0.2)', strokeStyle = 'purple', lineWidth = 2} = props;

    const canvasRef = useRef<HTMLCanvasElement | null>(null);

    useEffect(() => {
        const canvas = canvasRef.current;
        if (!canvas || !width || !height) return;

        canvas.width = width;
        canvas.height = height;

        const ctx = canvas.getContext('2d');
        if (!ctx) return;

        ctx.clearRect(0, 0, width, height);

        if (!markedAreas || markedAreas.length === 0) return;

        markedAreas.forEach((shape) => {
            if (!shape.points || shape.points.length < 2) return;
            ctx.beginPath();
            ctx.moveTo(shape.points[0].x * width, shape.points[0].y * height);
            shape.points.forEach((point: IPoint) => {
                ctx.lineTo(point.x * width, point.y * height);
            });
            ctx.closePath();
            ctx.fillStyle = fillStyle;
            ctx.fill();
            ctx.strokeStyle = strokeStyle;
            ctx.lineWidth = lineWidth;
            ctx.stroke();
        });
    }, [height, lineWidth, markedAreas, strokeStyle, fillStyle, width]);

    return (
        <canvas
            ref={canvasRef}
            style={{
                position: 'absolute',
                top: 0,
                left: '50%',
                transform: 'translateX(-50%)',
                zIndex: 1,
                pointerEvents: 'none',
                width: '100%',
                height: '100%',
            }}
        />
    );
}

export default CanvasQuestionMarkedAreas;
